import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addgrade',
  templateUrl: './addgrade.component.html',
  styleUrls: ['./addgrade.component.css']
})
export class AddgradeComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="Grade"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
gradeColl:any=[];
gradeBO:any={};

gradeid:number=0

gradeform=new FormGroup({
  gradeid:new FormControl(0),          
  gradename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.gradeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.gradeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.gradeid>0){
         this.fngetGrade();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.gradeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.gradeform.setValue({
    gradeid:0,    
    gradename:'',
     inactive:false              
   })
}

//Get 
fngetGrade() {
  if (this.showProgress) {
    return;
  }         
     var data = {
       'gradeid':this.gradeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getGrade(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.gradeColl=res.json().result;
           var editdata = this.gradeColl[0];        
           this.fnEditMode(editdata);
           this.gradeBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{   
      this.fnHideProgress();
       
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
      return;
    }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.gradeform.valid){
         //Check
         this.saveloading = true;
         var data = {
               'gradeid': this.gradeid,                      
               'gradename':this.gradeform.get('gradename').value, 
               'inactive':this.gradeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckGrade(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.gradeform.get('gradeid').value>0){
                       //Update 
                       this.fnSetGrade(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertGrade(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.gradeform.controls['gradename'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertGrade(data){    
 
   this.appService.fnInsertGrade(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){

          
          this.ischildkey=res.json().result[0][0].gradeid;
          this.ischildadd=true;

           this.toastr.success('', "The new grade has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.gradename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetGrade(data){    

this.appService.fnSetGrade(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The grade has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.gradeid,data.gradename);

             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  if(this.ischild===false){
    this.router.navigate(['/Grade']);
  }
  else{
    var pBO:any={
      isadd:this.ischildadd,
      childkey:this.ischildkey,
      doctype:'GRADE'    
    }
    this.childChanged.emit(pBO);
  }

}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.gradeform.setValue({ 
  gradeid:deptBO.gradeid,     
  gradename:deptBO.gradename,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}






}
